import React from "react";

import AppStoreLink from "./AppStoreLink";
import GooglePlayStoreLink from "./GooglePlayStoreLink";

export default function MobileStoreLinks({
  appStoreHref,
  googlePlayStoreHref,
}: {
  appStoreHref?: string | null;
  googlePlayStoreHref?: string | null;
}) {
  return (
    <div className='tw-my-[14px] tw-flex  tw-flex-row tw-gap-2 '>
      {appStoreHref && <AppStoreLink href={appStoreHref} />}
      {googlePlayStoreHref && <GooglePlayStoreLink href={googlePlayStoreHref} />}
    </div>
  );
}
